import Advantage from './Advantage';
export default Advantage;
